import Avatar from '@material-ui/core/Avatar';
import { SiGoldenline } from "react-icons/si";


const Logo = () => {
  return (
    <div className="logo">
        <Avatar alt="Studybud" src="" className="avatar"><SiGoldenline /></Avatar>
    </div>
  );
}

export default Logo;